export default __webpack_public_path__ + "videos/ecco_spinner.webm";